import React from "react";
import { Configuration, RedirectRequest } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_CLIENT_ID!;
const scopes = process.env.REACT_APP_AUTH_SCOPES!;

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: clientId,
        authority: "https://login.microsoftonline.com/c6b693b5-ec80-4956-9f59-0a4c0b4e9f51",
        redirectUri:"/Dashboard",
        postLogoutRedirectUri: "/",
    },
    system: {
        allowNativeBroker: false // Disables WAM Broker
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
    scopes: [scopes]
};